import { Component, Input } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';
import Highcharts from 'highcharts';
import { CommonModule } from '@angular/common';
import { HighchartsChartComponent } from 'highcharts-angular';

@Component({
  selector: 'app-post-trade-chart',
  templateUrl: './post-trade-chart.component.html',
  styleUrls: ['./post-trade-chart.component.scss'],
  imports: [CommonModule, HighchartsChartComponent],
})
export class PostTradeChartComponent {
  @Input() chart;
  Highcharts: typeof Highcharts = Highcharts;
  isEmpty = isEmpty;

  returnZero() {
    return 0;
  }
}
